module.exports = {"prices":{"location":"STN","per_day":"17.50","per_week":"139.99","two_week":"144.99","off_airport":null,"on_airport":"94.99","meet_and_greet":"118.00","per_day_off_airport":null,"per_day_on_airport":"11.87","per_day_meet_and_greet":"14.75","startDate":"29-07-2025","endDate":"05-08-2025","dateUsed":"29-05-2025"}}


//////////////////
// WEBPACK FOOTER
// ./config/exports/prices/parking/STN.json
// module id = 152
// module chunks = 119